module.exports = __webpack_public_path__ + "img/32_15.5a86bf10.png";